import { BenefitType } from '../service-proxies';


export class CompensationDto implements ICompensationDto {
    id!: number;
    compensationName!: string | undefined;
    shortCode!: string | undefined;
    benefitType!: BenefitType;
    benefitTypeName!: string | undefined;
    benefitValue!: number;
    isActive!: boolean;

    constructor(data?: ICompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.compensationName = _data["compensationName"];
            this.shortCode = _data["shortCode"];
            this.benefitType = _data["benefitType"];
            this.benefitTypeName = _data["benefitTypeName"];
            this.benefitValue = _data["benefitValue"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CompensationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["compensationName"] = this.compensationName;
        data["shortCode"] = this.shortCode;
        data["benefitType"] = this.benefitType;
        data["benefitTypeName"] = this.benefitTypeName;
        data["benefitValue"] = this.benefitValue;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICompensationDto {
    id: number;
    compensationName: string | undefined;
    shortCode: string | undefined;
    benefitType: BenefitType;
    benefitTypeName: string | undefined;
    benefitValue: number;
    isActive: boolean;
}

